import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { mdiArrowLeft, mdiEye, mdiEyeOff } from '@mdi/js'
import { getAuth, signInWithEmailAndPassword, updatePassword } from 'firebase/auth'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPassword',
  setup(__props) {

const currentPassword = ref<string>('')
const newPassword = ref<string>('')
const confirmNewPassword = ref<string>('')
const emailUser = ref<string | null>(null)
const isShowSectionPassword = ref<boolean>(false)
const showPassword = ref<boolean>(false)
const loading = ref<boolean>(false)
const error = ref<string | null>(null)

async function updatePasswordHandler() {
  if (!emailUser.value || !currentPassword.value || !getAuth() || !newPassword.value) {
    error.value = 'Something went wrong'
    return
  }
  await signInWithEmailAndPassword(getAuth(), emailUser.value, currentPassword.value)
    .then(() => updatePassword(getAuth().currentUser!, newPassword.value))
    .then(() => {
      currentPassword.value = ''
      newPassword.value = ''
      confirmNewPassword.value = ''
      store.dispatch('showAlertToast', 'changesSaved')
    })
    .catch((err) => {
      error.value = err.message
    })
}

const handlerClickSave = async () => {
  error.value = null

  if (!currentPassword.value || !newPassword.value || !confirmNewPassword.value) {
    error.value = 'All fields are required'
    return
  }

  if (newPassword.value !== confirmNewPassword.value) {
    error.value = 'Passwords must be equal'
    return
  }

  loading.value = true
  await updatePasswordHandler()
  loading.value = false
}

onMounted(() => {
  const { currentUser } = getAuth()
  if (currentUser) {
    emailUser.value = currentUser.providerData[0].email
    isShowSectionPassword.value = currentUser.providerData[0].providerId === 'password'
  }
})

return { __sfc: true,currentPassword, newPassword, confirmNewPassword, emailUser, isShowSectionPassword, showPassword, loading, error, updatePasswordHandler, handlerClickSave, mdiArrowLeft, mdiEye, mdiEyeOff, store }
}

})